__turbopack_context__.v({
  "active": "Arrow-module-scss-module__p0LJwq__active",
  "arrow": "Arrow-module-scss-module__p0LJwq__arrow",
  "arrowContainer": "Arrow-module-scss-module__p0LJwq__arrowContainer",
  "arrowHead": "Arrow-module-scss-module__p0LJwq__arrowHead",
  "onBackground": "Arrow-module-scss-module__p0LJwq__onBackground",
  "onSolid": "Arrow-module-scss-module__p0LJwq__onSolid",
});
